import {PlayerReduxState} from "../types";

export default function isResumeFailed(state: PlayerReduxState): boolean {
  return !!state.sessionResumeFailed;
}
